import { PackagesModal } from '@features/teacher/packages'

import React from 'react'

export const HistoryModals = () => <>
	<PackagesModal/>
</>
